module.exports = __webpack_public_path__ + "img/dph-app-logo.bfed54cd.png";